export default defineI18nLocale((locale) => {
  const config = useRuntimeConfig()
  return $fetch(`${config.public.API_URL}/localize/${locale}`)
})
